import { LayoutContextProps, LayoutContext } from 'providers/LayoutProvider'
import { useContext } from 'react'

/**
 * It uses the context from LayoutProvider to check the layout variant.
 */
const useLayout = (): LayoutContextProps => {
  const context = useContext(LayoutContext)

  if (context === null) {
    throw new Error('useLayout must be used within an LayoutProvider')
  }

  return context
}

export default useLayout
